import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.75 14.25L4.75 18C4.75 18.6904 5.30964 19.25 6 19.25L9.5 19.25M4.75 14.25L4.75 6C4.75 5.30964 5.30964 4.75 6 4.75L18 4.75C18.6904 4.75 19.25 5.30964 19.25 6L19.25 14.25M4.75 14.25L9.5 14.25M19.25 14.25L19.25 18C19.25 18.6904 18.6904 19.25 18 19.25L14.5 19.25M19.25 14.25L14.5 14.25M14.5 14.25L14.5 19.25M14.5 14.25L9.5 14.25M14.5 19.25L9.5 19.25M9.5 14.25L9.5 19.25" />
		<Path d="M12 6.5L12 9.5M12 12.5L12 9.5M12 9.5L9 9.5M12 9.5L15 9.5" />
	</SVG>
);
